import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `TipoDosis`, method: 'GET', body: null})
}